
import Company from '../../../component/systemMaster/Company/Company'

const Companytable = () => {

    return <Company/>
};

export default Companytable;
